module.exports = __webpack_public_path__ + "static/media/CO2.d08715a6.svg";